import {EActionStatus} from '@app/shared/enums/action-status.enum';
import {createReducer, on} from '@ngrx/store';
import {ECheckoutStatus} from '../enums/checkout-status.enum';
import {ICancelOrderState} from '../models/cancel-order-state.model';
import {ICheckoutState} from '../models/checkout.state.model';
import {IConsentPdfState} from '../models/consent-pdf-state.model';
import {ICustomerOrganization} from '../models/customer-organization.model';
import {Order} from '../models/order-request.model';
import {OrderResponse} from '../models/order-response.model';
import {
  cancelOrderAction,
  cancelOrderEffectError,
  cancelOrderEffectFailure,
  cancelOrderEffectSuccess,
  consentPdfAction,
  consentPdfEffectError,
  consentPdfEffectFailure,
  consentPdfEffectSuccess,
  getCustomerOrganizationSuccess,
  getOrderFailure,
  getOrderSuccess,
  getPatientRelationTypesSuccess,
  getSampleTypesSuccess,
  getSelectedOrganization,
  resetCheckoutStatus,
  resetGetOrderStatus,
  resetOrderFormDataFormNewOrderPage,
  resetOrderFormDataFromMyOrdersPage,
  saveOrderFailure,
  saveOrderSuccess,
  updateOrderFailure,
  updateOrderStatusSuccess,
  updateOrderSuccess,
} from './checkout.actions';

const initialOrderState: ICheckoutState = {
  orderData: {} as OrderResponse,
  orderFormData: {} as Order,
  customerOrganization: [],
  checkoutStatus: ECheckoutStatus.Initial,
  selectedOrganization: {} as ICustomerOrganization,
  status: EActionStatus.Initial,
  sampleTypes: [],
  patientRelationTypes: [],
};

export const checkoutReducer = createReducer(
  initialOrderState,
  on(getOrderSuccess, (state, {orderData, orderFormData}) => ({
    ...state,
    status: EActionStatus.Success,
    orderData: {...state.orderData, ...orderData},
    orderFormData: {...state.orderFormData, ...orderFormData},
  })),
  on(getOrderFailure, state => ({
    ...state,
    status: EActionStatus.Failure,
  })),
  on(resetGetOrderStatus, state => ({
    ...state,
    status: EActionStatus.Initial,
  })),
  on(saveOrderSuccess, (state, {orderData, checkoutStatus}) => ({
    ...state,
    orderData: {...state.orderData, ...orderData},
    checkoutStatus: checkoutStatus,
  })),
  on(saveOrderFailure, (state, {checkoutStatus}) => ({
    ...state,
    checkoutStatus: checkoutStatus,
  })),
  on(updateOrderSuccess, (state, {orderData, orderFormData, checkoutStatus}) => ({
    ...state,
    orderData: {...state.orderData, ...orderData},
    orderFormData: {...state.orderFormData, ...orderFormData},
    checkoutStatus: checkoutStatus,
  })),
  on(updateOrderFailure, (state, {checkoutStatus}) => ({
    ...state,
    checkoutStatus: checkoutStatus,
  })),
  on(updateOrderStatusSuccess, (state, {orderData}) => ({
    ...state,
    orderData: {...state.orderData, ...orderData},
  })),
  on(getCustomerOrganizationSuccess, (state, {customerOrganization}) => ({
    ...state,
    customerOrganization: {
      ...state.customerOrganization,
      customerOrganization,
    },
  })),
  on(getSelectedOrganization, (state, {selectedOrganization}) => ({
    ...state,
    selectedOrganization: selectedOrganization,
  })),

  on(resetCheckoutStatus, state => ({
    ...state,
    checkoutStatus: ECheckoutStatus.Initial,
  })),
  on(getSampleTypesSuccess, (state, {sampleTypes}) => ({
    ...state,
    sampleTypes: sampleTypes,
  })),
  on(getPatientRelationTypesSuccess, (state, {patientRelationTypes}) => ({
    ...state,
    patientRelationTypes: patientRelationTypes,
  })),
  on(resetOrderFormDataFormNewOrderPage, resetOrderFormDataFromMyOrdersPage, state => ({
    ...state,
    orderFormData: {} as Order,
  }))
);

const initialState: IConsentPdfState = {
  status: EActionStatus.Initial,
  successResponse: null,
  failureReason: '',
  errorMessage: '',
};
export const consentPdfReducer = createReducer(
  initialState,
  on(consentPdfAction, state => ({
    ...state,
    status: EActionStatus.Pending,
  })),
  on(consentPdfEffectSuccess, state => ({
    ...state,
    status: EActionStatus.Success,
  })),
  on(consentPdfEffectFailure, (state, {reason}) => ({
    ...state,
    status: EActionStatus.Failure,
    failureReason: reason,
  })),
  on(consentPdfEffectError, (state, {error}) => ({
    ...state,
    status: EActionStatus.Error,
    errorMessage: error,
  }))
);

const initialClinicalState: ICancelOrderState = {
  status: EActionStatus.Initial,
  successResponse: null,
  failureReason: '',
  errorMessage: '',
};
export const cancelOrderReducer = createReducer(
  initialClinicalState,
  on(cancelOrderAction, state => ({
    ...state,
    status: EActionStatus.Pending,
  })),
  on(cancelOrderEffectSuccess, (state, {response}) => ({
    ...state,
    status: EActionStatus.Success,
    successResponse: response,
  })),
  on(cancelOrderEffectFailure, (state, {reason}) => ({
    ...state,
    status: EActionStatus.Failure,
    failureReason: reason,
  })),
  on(cancelOrderEffectError, (state, {error}) => ({
    ...state,
    status: EActionStatus.Error,
    errorMessage: error,
  }))
);
